import { render, staticRenderFns } from "./veStuEvaluationConfigEdit.vue?vue&type=template&id=bfa896e4&scoped=true"
import script from "./veStuEvaluationConfigEdit.vue?vue&type=script&lang=js"
export * from "./veStuEvaluationConfigEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bfa896e4",
  null
  
)

export default component.exports